import React, { memo, useState, useEffect } from 'react';
import {
  AccordionItem,
  Box,
  Flex,
  Heading,
  Text,
  Radio,
  RadioGroup,
  VStack,
  Accordion,
} from '@chakra-ui/react';

import { useForm, SubmitHandler } from 'react-hook-form';

import { Label, CheckboxComp, Button, Modal } from 'components';

import { Container } from './components/RadioButton/style';

import { AccordionBody, AccordionHeader } from 'components/MultipleAccordion/components/Accordion';

import { colors } from 'theme/colors';
import { FlexCheckBox } from './styles';
import { ISimulation, ISimulationThirthStepQuestionFive } from 'models/Forms/Simultation';
import { InputMaskCurrency } from './components/InputMask';
import { IStepOneSimulation } from 'types/simulation';
import { openNotification } from 'utils/notification';
import { TableTip } from 'pages/Private/FineSimulator/components/TableTip';
import { createSecondStepSimulation } from 'services/createRegisterLandingPage';
import { BodyProps } from 'constants/MultipleAcorddions';

interface IProps extends BodyProps {
  setComponent: React.Dispatch<React.SetStateAction<string>>;
}

const Simulator: React.FC<IProps> = ({ setComponent }) => {
  const [activeIndex, setActiveIndex] = useState<number[] | number | undefined>();

  const [resultSimulation, setResultSimulation] = useState<number>(0);
  const { register, handleSubmit } = useForm<ISimulation>();

  const [noBilling, setNoBilling] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [oneStep, setOneStep] = useState<IStepOneSimulation>({
    infracao10: true,
  } as IStepOneSimulation);

  const [fiveStep, setFiveStep] = useState({
    isNone: true,
  } as ISimulationThirthStepQuestionFive);

  const [fourStep, setFourStep] = useState(false);

  const [isCompleted, setIsCompleted] = useState<boolean>(false);

  const handleCancel = () => {
    window.location.reload();
    setComponent('simulate');
  };

  const onSubmit: SubmitHandler<ISimulation> = async data => {
    try {
      setLoading(true);
      window.scroll(0, 0);

      const request = {
        ...data,
        infracao1: oneStep.infracao1 === undefined ? false : oneStep.infracao1,
        infracao2: oneStep.infracao2 === undefined ? false : oneStep.infracao2,
        infracao3: oneStep.infracao3 === undefined ? false : oneStep.infracao3,
        infracao4: oneStep.infracao4 === undefined ? false : oneStep.infracao4,
        infracao5: oneStep.infracao5 === undefined ? false : oneStep.infracao5,
        infracao6: oneStep.infracao6 === undefined ? false : oneStep.infracao6,
        infracao7: oneStep.infracao7 === undefined ? false : oneStep.infracao7,
        infracao8: oneStep.infracao8 === undefined ? false : oneStep.infracao8,
        infracao9: oneStep.infracao9 === undefined ? false : oneStep.infracao9,
        infracao10: oneStep.infracao10 === undefined ? false : oneStep.infracao10,

        etapa3pergunta5campo1: fiveStep.isNone ? false : data.etapa3pergunta5campo1,
        etapa3pergunta5campo2: fiveStep.isNone ? false : data.etapa3pergunta5campo2,
        etapa3pergunta5campo3: fiveStep.isNone ? false : data.etapa3pergunta5campo3,
        etapa3pergunta5campo4: fiveStep.isNone ? false : data.etapa3pergunta5campo4,
        etapa3pergunta5campo5: fiveStep.isNone ? false : data.etapa3pergunta5campo5,
        etapa3pergunta5campo6: fiveStep.isNone ? false : data.etapa3pergunta5campo6,
        etapa3pergunta5campo7: fiveStep.isNone ? false : data.etapa3pergunta5campo7,

        client: null,
        createdAt: new Date(),
        enabled: true,

        naoTemFaturamento: noBilling,

        valorFaturamento: noBilling
          ? 0
          : Number(String(data.valorFaturamento).replaceAll('.', '').replace(',', '.')),
        valorSimulado: 0,
        valorTributos: noBilling
          ? 0
          : Number(String(data.valorTributos).replaceAll('.', '').replace(',', '.')),
        files: undefined,
        filePath: 'a',
        filename: 'a',
        grauInfracao: '',

        valorVantagemAuferidaEstimavel: fourStep
          ? 0
          : Number(
              String(data.valorVantagemAuferidaEstimavel).replaceAll('.', '').replace(',', '.'),
            ),
      };

      if (
        !oneStep.infracao1 &&
        !oneStep.infracao2 &&
        !oneStep.infracao3 &&
        !oneStep.infracao3 &&
        !oneStep.infracao4 &&
        !oneStep.infracao5 &&
        !oneStep.infracao6 &&
        !oneStep.infracao7 &&
        !oneStep.infracao8 &&
        !oneStep.infracao9 &&
        !oneStep.infracao10
      ) {
        setLoading(false);
        openNotification(
          'E preciso marcar ao menos uma opção na etapa 1 Determinação da Alíquota Base.',
          'error',
        );
        return;
      }

      if (
        !data.etapa3pergunta5campo1 &&
        !data.etapa3pergunta5campo2 &&
        !data.etapa3pergunta5campo3 &&
        !data.etapa3pergunta5campo4 &&
        !data.etapa3pergunta5campo5 &&
        !data.etapa3pergunta5campo6 &&
        !data.etapa3pergunta5campo7 &&
        fiveStep.isNone === false
      ) {
        setLoading(false);
        openNotification(
          'E preciso marcar ao menos uma opção na etapa 3 Determinação do Valor da Multa.',
          'error',
        );
        return;
      }

      if (fourStep === false && request.valorVantagemAuferidaEstimavel === 0) {
        setLoading(false);
        openNotification(
          'E preciso marcar ao menos uma opção na etapa 4 Vantagem Estimável.',
          'error',
        );
        return;
      }

      delete request.files;

      const idSimulation = localStorage.getItem('id-simulation') as string;

      const newDate = {
        ...request,
      };

      const token = localStorage.getItem('LP-token') as string;

      const secondeStepSimulation = await createSecondStepSimulation(idSimulation, newDate, token);

      setLoading(false);

      setResultSimulation(secondeStepSimulation.data.valorSimulado);
      setIsCompleted(true);

      setActiveIndex(4);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const token = localStorage.getItem('LP-token');
    if (token === null) {
      setComponent('register');
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box w="100%" marginTop="5rem" marginBottom="5rem">
      <Box m="0 auto" maxW="50rem" width="100%">
        <h1 style={{ color: '#7E225A' }}>Simulador de multas</h1>
        <Accordion index={activeIndex} allowMultiple>
          <Flex direction="column">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* DETERMINAÇÃO DA ALÍQUOTA-BASE  */}

              <AccordionItem border="none" isDisabled={false}>
                <AccordionHeader index={1}>
                  <Heading size="sm">Determinação da Alíquota-Base</Heading>
                </AccordionHeader>
                <AccordionBody padding="1rem 1.5rem">
                  <Flex width="100%" direction="column">
                    <Box>
                      <Label width="45rem" placement="left">
                        Selecione abaixo a(s) situação(ões) que melhor se enquadra(m) ao seu caso
                      </Label>

                      <Flex m="0.2rem 0rem 0.5rem 0rem" mt="1rem" flexDirection="column">
                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao1}
                            {...register('infracao1')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao1: !oneStep.infracao1,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A infração envolve tratamento de dados pessoais em larga escala
                          </CheckboxComp>
                        </FlexCheckBox>
                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao2}
                            {...register('infracao2')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao2: !oneStep.infracao2,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A infração afeta significativamente interesses e direitos fundamentais
                            dos titulares
                          </CheckboxComp>
                        </FlexCheckBox>

                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao3}
                            {...register('infracao3')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao3: !oneStep.infracao3,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A empresa auferiu ou pretendia auferir vantagem econômica em decorrência
                            da infração cometida
                          </CheckboxComp>
                        </FlexCheckBox>

                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao4}
                            {...register('infracao4')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao4: !oneStep.infracao4,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A infração implica risco à vida ou à integridade física dos titulares.
                          </CheckboxComp>
                        </FlexCheckBox>

                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao5}
                            {...register('infracao5')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao5: !oneStep.infracao5,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A infração envolve dados sensíveis ou dados pessoais de crianças,
                            adolescentes ou idosos
                          </CheckboxComp>
                        </FlexCheckBox>

                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao6}
                            {...register('infracao6')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao6: !oneStep.infracao6,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A atividade não tem amparo em uma das bases legais da LGPD
                          </CheckboxComp>
                        </FlexCheckBox>
                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao7}
                            {...register('infracao7')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao7: !oneStep.infracao7,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A empresa realiza tratamento com efeitos discriminatórios, ilícitos ou
                            abusivos
                          </CheckboxComp>
                        </FlexCheckBox>
                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao8}
                            {...register('infracao8')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao8: !oneStep.infracao8,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A empresa adota de forma sistemática práticas irregulares
                          </CheckboxComp>
                        </FlexCheckBox>
                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao9}
                            {...register('infracao9')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao9: !oneStep.infracao9,
                                  infracao10: false,
                                };
                              })
                            }
                          >
                            A empresa praticou ato que possa obstaculizar a fiscalização
                          </CheckboxComp>
                        </FlexCheckBox>
                        <FlexCheckBox>
                          <CheckboxComp
                            isChecked={oneStep.infracao10}
                            {...register('infracao10')}
                            onChange={() =>
                              setOneStep(oldState => {
                                return {
                                  ...oldState,
                                  infracao1: false,
                                  infracao2: false,
                                  infracao3: false,
                                  infracao4: false,
                                  infracao5: false,
                                  infracao6: false,
                                  infracao7: false,
                                  infracao8: false,
                                  infracao9: false,
                                  infracao10: !oneStep.infracao10,
                                };
                              })
                            }
                          >
                            Nenhuma das alternativas se aplica
                          </CheckboxComp>
                        </FlexCheckBox>
                      </Flex>

                      <Label width="45rem" placement="left" tip={<TableTip />}>
                        Qual grau do dano melhor se enquadra ao caso?
                      </Label>

                      <Flex mt="0.5rem" flexDirection="column" maxWidth="33%">
                        <RadioGroup defaultValue="0">
                          <Container>
                            <Radio value="0" {...register('grauDano')}>
                              Grau de Dano 0
                            </Radio>
                            <Radio value="1" {...register('grauDano')}>
                              Grau de Dano 1
                            </Radio>
                            <Radio value="2" {...register('grauDano')}>
                              Grau de Dano 2
                            </Radio>
                            <Radio value="3" {...register('grauDano')}>
                              Grau de Dano 3
                            </Radio>
                          </Container>
                        </RadioGroup>
                      </Flex>
                    </Box>
                  </Flex>
                </AccordionBody>
              </AccordionItem>

              {/* DETERMINAÇÃO DO VALOR BASE  */}
              <AccordionItem border="none" isDisabled={false}>
                <AccordionHeader index={2}>
                  <Heading size="sm">Determinação do Valor Base</Heading>
                </AccordionHeader>
                <AccordionBody padding="1rem 1.5rem">
                  <Flex width="100%" direction="column">
                    <Box mb="6px">
                      <Label>Qual o faturamento aproximado da empresa? </Label>

                      <Text as="small">
                        <i>
                          Digite obrigatóriamente o valor abaixo ou marque a opção
                          <b> caso não tiver faturamento</b>
                        </i>
                      </Text>
                      <Flex mt="1rem" mb="0.5rem" flexDir="column">
                        <CheckboxComp value={noBilling} onChange={() => setNoBilling(!noBilling)}>
                          Não tenho faturamento
                        </CheckboxComp>

                        {!noBilling && (
                          <>
                            <Text
                              hidden={noBilling}
                              fontWeight={700}
                              mb="0.3rem"
                              fontSize="0.9rem"
                              color={colors.brand.tertiary}
                            >
                              Valor do Faturamento
                            </Text>

                            <InputMaskCurrency
                              id="valorFaturamento"
                              {...register('valorFaturamento')}
                              hidden={noBilling}
                            />
                          </>
                        )}
                      </Flex>
                      {!noBilling && (
                        <>
                          <Label>
                            Qual é o valor pago aproximado a título de tributos pela empresa?
                          </Label>

                          <Flex mt="1rem" mb="0.5rem" direction="column">
                            <Text
                              fontWeight={700}
                              mb="0.3rem"
                              color={colors.brand.tertiary}
                              fontSize="0.9rem"
                            >
                              Valor dos Tributos
                            </Text>
                            <InputMaskCurrency
                              id="valorTributos"
                              {...register('valorTributos')}
                              hidden={noBilling}
                            />
                          </Flex>
                        </>
                      )}
                    </Box>
                  </Flex>
                </AccordionBody>
              </AccordionItem>
              {/* DETERMINAÇÃO DO VALOR DA MULTA  */}
              <AccordionItem border="none" isDisabled={false}>
                <AccordionHeader index={3}>
                  <Heading size="sm">Determinação do Valor da Multa</Heading>
                </AccordionHeader>
                <AccordionBody padding="1rem 1.5rem">
                  <Flex width="100%" direction="column">
                    <Flex flexDir="column">
                      <Box mb="0.5rem">
                        <Label width="45rem" placement="left">
                          Para fins de cálculo de possíveis agravantes, selecione uma ou mais
                          opções:
                        </Label>
                      </Box>

                      <Box mb="0.5rem">
                        <Label>
                          A empresa já foi sancionada pela ANPD em outra oportunidade pelo mesmo
                          fundamento, nos últimos 5 anos? Se sim, quantas vezes?
                        </Label>
                      </Box>

                      <Flex m="0.2rem 0rem 1.5rem 0rem" flexDirection="column" maxWidth="33%">
                        <RadioGroup defaultValue="Nenhum">
                          <Container>
                            <Radio value="Nenhum" {...register('etapa3pergunta1')}>
                              Nenhuma
                            </Radio>
                            <Radio value="Uma (10%)" {...register('etapa3pergunta1')}>
                              Uma
                            </Radio>
                            <Radio value="Duas (20%)" {...register('etapa3pergunta1')}>
                              Duas
                            </Radio>
                            <Radio value="Três (30%)" {...register('etapa3pergunta1')}>
                              Três
                            </Radio>
                            <Radio value="Quatro (40%)" {...register('etapa3pergunta1')}>
                              Quatro
                            </Radio>
                            <Radio value="Quatro ou mais (40%)" {...register('etapa3pergunta1')}>
                              Mais de quatro
                            </Radio>
                          </Container>
                        </RadioGroup>
                      </Flex>

                      <Label>
                        A empresa já foi sancionada pela ANPD em outra oportunidade, nos últimos 5
                        anos? Se sim, quantas vezes?
                      </Label>
                      <Flex m="0.2rem 0rem 1.5rem 0rem" flexDirection="column" maxWidth="33%">
                        <RadioGroup defaultValue="Nenhum">
                          <Container>
                            <Radio value="Nenhum" {...register('etapa3pergunta2')}>
                              Nenhuma
                            </Radio>
                            <Radio value="Uma (5%)" {...register('etapa3pergunta2')}>
                              Uma
                            </Radio>
                            <Radio value="Duas (10%)" {...register('etapa3pergunta2')}>
                              Duas
                            </Radio>
                            <Radio value="Três (15%)" {...register('etapa3pergunta2')}>
                              Três
                            </Radio>
                            <Radio value="Quatro (20%)" {...register('etapa3pergunta2')}>
                              Quatro
                            </Radio>
                            <Radio value="Mais de quatro (20%)" {...register('etapa3pergunta2')}>
                              Mais de quatro
                            </Radio>
                          </Container>
                        </RadioGroup>
                      </Flex>

                      <Label>
                        A empresa descumpriu alguma medida de orientação/prevenção da ANPD
                        determinada durante o processo de fiscalização ou procedimento preparatório?
                        Se sim, quantas vezes?
                      </Label>
                      <Flex m="0.2rem 0rem 1.5rem 0rem" flexDirection="column">
                        <RadioGroup defaultValue="Nenhum" mb="1.5rem">
                          <Container>
                            <Radio value="Nenhum" {...register('etapa3pergunta3')}>
                              Nenhuma
                            </Radio>
                            <Radio value="Uma (20%)" {...register('etapa3pergunta3')}>
                              Uma
                            </Radio>
                            <Radio value="Duas (40%)" {...register('etapa3pergunta3')}>
                              Duas
                            </Radio>
                            <Radio value="Três (60%)" {...register('etapa3pergunta3')}>
                              Três
                            </Radio>
                            <Radio value="Quatro (80%)" {...register('etapa3pergunta3')}>
                              Quatro
                            </Radio>
                            <Radio value="Mais de quatro (80%)" {...register('etapa3pergunta3')}>
                              Mais de quatro
                            </Radio>
                          </Container>
                        </RadioGroup>

                        <Label>
                          A empresa descumpriu alguma medida corretiva da ANPD? Se sim, quantas
                          vezes?
                        </Label>
                        <Flex m="0.2rem 0rem 1.5rem 0rem" flexDirection="column">
                          <RadioGroup defaultValue="Nenhum">
                            <Container>
                              <Radio value="Nenhum" {...register('etapa3pergunta4')}>
                                Nenhuma
                              </Radio>
                              <Radio value="Uma (30%)" {...register('etapa3pergunta4')}>
                                Uma
                              </Radio>
                              <Radio value="Duas (60%)" {...register('etapa3pergunta4')}>
                                Duas
                              </Radio>
                              <Radio value="Três (90%)" {...register('etapa3pergunta4')}>
                                Três
                              </Radio>
                              <Radio value="Mais de três (90%)" {...register('etapa3pergunta4')}>
                                Mais de três
                              </Radio>
                            </Container>
                          </RadioGroup>
                        </Flex>

                        <Label width="45rem" placement="left">
                          Para fins do cálculo de possíveis atenuantes, selecione uma ou mais
                          opções:
                        </Label>

                        <Text as="small" mb="1rem">
                          <i>
                            Selecione <b>uma ou mais opções</b>
                          </i>
                        </Text>

                        <Flex m="0.2rem 0rem 1.5rem 0rem" flexDirection="column">
                          <FlexCheckBox>
                            <CheckboxComp
                              value="Nenhuma"
                              isChecked={fiveStep.isNone}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo1: false,
                                    etapa3pergunta5campo2: false,
                                    etapa3pergunta5campo3: false,
                                    etapa3pergunta5campo4: false,
                                    etapa3pergunta5campo5: false,
                                    etapa3pergunta5campo6: false,
                                    etapa3pergunta5campo7: false,
                                    isNone: !fiveStep.isNone,
                                  };
                                })
                              }
                            >
                              Nenhuma
                            </CheckboxComp>
                          </FlexCheckBox>
                          <FlexCheckBox>
                            <CheckboxComp
                              isChecked={fiveStep.etapa3pergunta5campo1}
                              {...register('etapa3pergunta5campo1')}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo1: !fiveStep.etapa3pergunta5campo1,
                                    isNone: false,
                                  };
                                })
                              }
                            >
                              A infração investigada foi cessada em momento anterior à instauração
                              de procedimento preparatório pela ANPD
                            </CheckboxComp>
                          </FlexCheckBox>

                          <FlexCheckBox>
                            <CheckboxComp
                              isChecked={fiveStep.etapa3pergunta5campo2}
                              {...register('etapa3pergunta5campo2')}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo2: !fiveStep.etapa3pergunta5campo2,
                                    isNone: false,
                                  };
                                })
                              }
                            >
                              A infração investigada foi cessada entre o procedimento preparatório e
                              a instauração de processo administrativo sancionador
                            </CheckboxComp>
                          </FlexCheckBox>

                          <FlexCheckBox>
                            <CheckboxComp
                              isChecked={fiveStep.etapa3pergunta5campo3}
                              {...register('etapa3pergunta5campo3')}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo3: !fiveStep.etapa3pergunta5campo3,
                                    isNone: false,
                                  };
                                })
                              }
                            >
                              A infração investigada foi cessada após a instauração do processo
                              administrativo sancionador e antes da prolação da decisão em primeira
                              instância
                            </CheckboxComp>
                          </FlexCheckBox>

                          <FlexCheckBox>
                            <CheckboxComp
                              isChecked={fiveStep.etapa3pergunta5campo4}
                              {...register('etapa3pergunta5campo4')}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo4: !fiveStep.etapa3pergunta5campo4,
                                    isNone: false,
                                  };
                                })
                              }
                            >
                              A empresa implementou política de boas práticas e governança ou
                              demonstrou a adoção de mecanismos e procedimentos internos de
                              minimização de danos aos titulares até a prolação da decisão na
                              primeira instância
                            </CheckboxComp>
                          </FlexCheckBox>

                          <FlexCheckBox>
                            <CheckboxComp
                              isChecked={fiveStep.etapa3pergunta5campo5}
                              {...register('etapa3pergunta5campo5')}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo5: !fiveStep.etapa3pergunta5campo5,
                                    isNone: false,
                                  };
                                })
                              }
                            >
                              A empresa implementou medidas capazes de reverter ou mitigar os
                              efeitos da infração sobre os titulares antes da instauração de
                              procedimento preparatório ou processo administrativo sancionador
                            </CheckboxComp>
                          </FlexCheckBox>
                          <FlexCheckBox>
                            <CheckboxComp
                              isChecked={fiveStep.etapa3pergunta5campo6}
                              {...register('etapa3pergunta5campo6')}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo6: !fiveStep.etapa3pergunta5campo6,
                                    isNone: false,
                                  };
                                })
                              }
                            >
                              A empresa implementou medidas capazes de reverter ou mitigar os
                              efeitos da infração sobre os titulares após a instauração de
                              procedimento preparatório, mas antes da instauração de processo
                              administrativo sancionador
                            </CheckboxComp>
                          </FlexCheckBox>
                          <FlexCheckBox>
                            <CheckboxComp
                              isChecked={fiveStep.etapa3pergunta5campo7}
                              {...register('etapa3pergunta5campo7')}
                              onChange={() =>
                                setFiveStep(oldState => {
                                  return {
                                    ...oldState,
                                    etapa3pergunta5campo7: !fiveStep.etapa3pergunta5campo7,
                                    isNone: false,
                                  };
                                })
                              }
                            >
                              É possível verificar a cooperação ou a boa-fé por parte da empresa
                            </CheckboxComp>
                          </FlexCheckBox>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem border="none" isDisabled={false}>
                <AccordionHeader index={4}>
                  <Heading size="sm">Vantagem Estimável</Heading>
                </AccordionHeader>
                <AccordionBody padding="1rem 1.5rem">
                  <Flex width="100%" direction="column">
                    <Box mb="6px">
                      <Label>
                        É possível estimar a vantagem econômica auferida ou pretendida por meio da
                        infração?
                      </Label>

                      <Flex mt="0.5rem" flexDir="column">
                        <CheckboxComp
                          value={fourStep}
                          onChange={() => setFourStep(!fourStep)}
                          marginBottom="0.7rem !important"
                        >
                          Não
                        </CheckboxComp>

                        {!fourStep && (
                          <>
                            <Text
                              hidden={fourStep}
                              fontWeight={700}
                              mb="0.3rem"
                              fontSize="0.9rem"
                              color={colors.brand.tertiary}
                            >
                              Se sim, qual o valor ?
                            </Text>

                            <InputMaskCurrency
                              id="valorFaturamento"
                              {...register('valorVantagemAuferidaEstimavel')}
                              hidden={fourStep}
                            />
                          </>
                        )}
                      </Flex>
                    </Box>

                    <Flex w="100%" justify="space-between" pt="1rem">
                      <Modal
                        title="Cancelar"
                        header="Cancelar Simulação"
                        body="Tem certeza que gostaria de cancelar a solicitação de simulação de multa?"
                        noText="Não"
                        yesText="Sim, quero cancelar"
                        onClick={handleCancel}
                      />
                      <Button type={'submit'} isLoading={loading}>
                        Calcular
                      </Button>
                    </Flex>
                  </Flex>
                </AccordionBody>
              </AccordionItem>
            </form>

            {/* VALOR SIMULADO DA MULTA  */}
            <AccordionItem>
              <AccordionHeader index={5}>
                <Heading size="sm">Valor Simulado da Multa</Heading>
              </AccordionHeader>
              <AccordionBody padding="1rem 1.5rem">
                <Flex width="100%" direction="column">
                  <VStack spacing="1rem">
                    <Label>O valor da multa seria em torno de</Label>

                    {isCompleted && (
                      <Flex width="100%" justifyContent="space-between" align="center">
                        <Box>
                          <Heading fontSize="2rem" color={colors.brand.primary}>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(resultSimulation)}
                          </Heading>
                          <Text as="small" mb="1rem">
                            <i>*Este valor é uma simulação.</i> <br />
                            <i>Você receberá mais informações no seu e-mail.</i>
                          </Text>
                        </Box>

                        <Button onClick={() => setComponent('register')}>Ir para o início</Button>
                      </Flex>
                    )}
                  </VStack>
                </Flex>
              </AccordionBody>
            </AccordionItem>
          </Flex>
        </Accordion>
      </Box>
    </Box>
  );
};

export const FormSimulator = memo(Simulator);
